import CompletionNumberLabel from './CompletionNumberLabel'
export class RequestCompletionNumber {
    ID?: number;
    RequestID: number;
    Number: string;
    CompletionNumberLabelID?: number;
    CompletionNumberLabel?: CompletionNumberLabel;
    EquipmentLineItemIdentifier?: string;
    PartnerType?: string;
    MoreInfo?: string;
}

export default RequestCompletionNumber;